function getIEVersion() {
  const sAgent = window.navigator.userAgent;
  const Idx = sAgent.indexOf('MSIE');

  // If IE, return version number.
  if (Idx > 0) {
    return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)), 10);
    // If IE 11 then look for Updated user agent string.
  } else if (!!navigator.userAgent.match(/Trident\/7\./)) {
    return 11;
  }

  return 0; // It is not IE
}

export const getBrowserInfo = () => {
  const ieVersion = getIEVersion();

  return {
    name: ieVersion > 0 ? 'ie' : null,
    version: ieVersion || null,
  };
};
